import Vue from 'vue'
import errors from '@/store/errors'
import constants, { METHODS } from '@/const'

const vue = Vue.prototype
const actions = {
	getClientsStatisticsData: async function ({ state, commit, getters, rootState }, input) {
		commit('setClientsStatisticsData', [])
		try {
			const result = await rootState.request({
				type: METHODS.GET,
				apiName: 'hqsw',
				url: 'bridge/seowork/clients/statistics',
				auth: true,
				query: input?.query
			})

			if (result.has_data && result.data) {
				commit('setClientsStatisticsData', result.data)
				return result.data
			}
		} catch (e) {
			vue.$notify({ type: 'error', title: errors.GET_DATA })
			return false
		}
	},

	updateLimitValue: function ({ rootState }, input) {
		console.log(input)
		return new Promise((resolve, reject) => {
			rootState.request({
				type: constants.METHODS.POST,
				url: 'api/clients/' + input.body.client_id + '/data-unit-limit',
				apiName: 'hqsw',
				auth: true,
				body: input.body
			})
				.then(result => {
					resolve(result && result.status === 200)
				}, () => {
					reject(Error(errors.CREATE))
				})
		})
	}
}

export default actions
